// extracted by mini-css-extract-plugin
export default {"header-banner":"header-banner-ff20","showMenu":"showMenu-2728","LA":"LA-df01"};